import { http } from './axios';
import { httpGenerator } from './axios';
import { toastSuccess } from './toasters';
import { localization_fa } from './localization_fa';
export const backendUrl = 'https://pmrsapi.asft.co:443';
 //"http://127.0.0.1:8000";

// export const backendUrl = 'http://
//'http://127.0.0.1:8000';


export {
    http,
    localization_fa,
    httpGenerator,
    toastSuccess,
}